/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Pricing_Feature1Inputs */

const ja_playdata_pricing_feature1 = /** @type {(inputs: Playdata_Pricing_Feature1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日程別同時視聴者数の推移`)
};

const en_playdata_pricing_feature1 = /** @type {(inputs: Playdata_Pricing_Feature1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changes in viewership by date`)
};

/**
* | output |
* | --- |
* | "Changes in viewership by date" |
*
* @param {Playdata_Pricing_Feature1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_pricing_feature1 = /** @type {((inputs?: Playdata_Pricing_Feature1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Pricing_Feature1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_pricing_feature1(inputs)
	return en_playdata_pricing_feature1(inputs)
});